import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconChartRadiusGray,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo4.mp4';

export default {
  type: '제조 솔루션',
  banner: {
    title: '복잡한 공정을 실시간으로 추적하고, 데이터 기반 공장 운영을 실현하세요',
    desc: '작업자·장비·자산의 위치와 상태를 실시간으로 추적하여 공정 흐름을 투명하게 관리하고, 병목 현상이나 비효율을 빠르게 개선할 수 있습니다.',
  },

  video: {
    title: '제조 현장의 흐름을 데이터로 가시화하여 공정 효율을 높입니다',
    desc: '위치 데이터 기반의 공정 추적 시스템은 설비 가동률, 작업자 동선, 재고 흐름을 실시간으로 파악해 생산성 향상은 물론 품질 개선과 납기 준수까지 지원합니다.',
    play: video,
  },

  func: [
    {
      theme: '생산 흐름 실시간 추적 및 공정 최적화',
      title: '작업자 및 장비 위치 실시간 모니터링',
      desc: '작업자의 실시간 위치와 동선을 분석해 위험 지역 접근을 감지하고, 설비 위치 데이터를 통해 장비 가동 여부 및 이동 경로를 자동 기록함으로써 불필요한 비효율을 줄이고 공정 흐름을 최적화할 수 있습니다.',
      sub1: '실시간 현황 파악',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      video: subVideo1,
    },
    {
      title: '공정 병목 구간 탐지 및 개선 지원',
      desc: '위치 데이터와 동선 로그를 기반으로, 공정마다 체류 시간이 비정상적으로 길어지는 지점을 자동으로 식별하고 문제 지점을 시각화하여 신속한 개선 조치를 가능하게 합니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      video: subVideo2,
    },
    {
      title: '생산 흐름의 시각화 및 자동 리포팅',
      desc: '작업자 및 자산의 위치 정보를 토대로 생산 흐름을 공정 단위로 구분하여 맵 기반으로 시각화하고, 시간대별/라인별 공정 효율 리포트를 자동으로 생성해 관리자 보고 및 개선 회의에 활용할 수 있습니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '대응 방식 설정',
      icon2: IconChartRadiusGray,
      video: subVideo3,
    },
    {
      theme: '생산 품질 및 운영 효율 향상',
      title: '이상 이벤트 자동 감지 및 알림',
      desc: '작업자 이탈, 장비 오작동, 안전구역 무단 접근 등 이상 상황을 자동 감지하고 알림으로 전달하여 즉각적인 대응이 가능하며, 품질 이슈를 사전에 차단하는 데 기여합니다.',
      sub1: '데이터 클라우드 저장',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      video: subVideo4,
    },
    {
      title: '작업자 안전 및 출입 관리 통합 운영',
      desc: '위험 구역 접근 제한, 실시간 출입 로그 관리, 출입 시간 기반 근태 분석 등 다양한 운영 정보가 통합 관리되어 제조 환경의 안전성과 운영 효율을 동시에 높일 수 있습니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '대응 방식 설정',
      icon2: IconChartRadiusGray,
      video: subVideo1,
    },
    {
      title: '데이터 기반 생산 스케줄 조정',
      desc: '실시간 위치 데이터를 활용하여 자산과 인력의 가용성을 분석하고, 공정간 흐름을 기준으로 생산 일정을 유연하게 조정함으로써 납기 준수와 리소스 최적 배치를 동시에 달성할 수 있습니다.',
      sub1: '데이터 클라우드 저장',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      video: subVideo2,
    },
  ],
  subfunc: {
    title: '다양한 기능',
    desc: '공정 라인의 생산성은 제조 산업의 핵심이라 할 수 있습니다. 오브로가 제공하는 기능들은 공정 라인의 효율성과 생산성을 모두 한층 더 끌어 올릴 수 있습니다.',

    data: [
      {
        icon: IconChartRadius,
        title: '리포트 및 분석',
        desc: '현장 데이터를 기반으로 보고서 및 분석 자료를 생성할 수 있습니다.',
      },
      {
        icon: IconBell,
        title: '실시간 알람 기능',
        desc: '공정라인에 이상 상황이 발생하는 경우 알람을 보내 즉각적으로 대처할 수 있습니다.',
      },
      {
        icon: IconRoute,
        title: '동선 이력 조회',
        desc: '내부의 이동 물체가 이동하는 경로와 이동 시간을 추적하여 확인할 수 있습니다.',
      },
      {
        icon: IconDashboard,
        title: '현황 파악',
        desc: '현재 공정 상황을 실시간으로 파악할 수 있습니다.',
      },
      {
        icon: IconTemp,
        title: '온도, 습도 등 환경분석',
        desc: '물류창고 내부 환경 요인을 모니터링하여 이상이 있는 경우 실시간으로 감지할 수 있습니다.',
      },
      {
        icon: IconUserCheck,
        title: '작업자 지시',
        desc: '현 상황을 바탕으로 작업자에게 다음 작업을 지시할 수 있습니다.',
      },
      {
        icon: IconChainLink,
        title: '데이터 연동',
        desc: 'RFID, IOT, 보안, 영상 등의 시스템과 연결하여 효율적으로 활용할 수 있습니다.',
      },
      {
        icon: IconSecurity,
        title: '데이터 보안',
        desc: '높은 데이터 보안 수준을 유지하여 신뢰성이 높은 솔루션을 제공합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'manufacturingAsset',
    },
    {
      data: 'logisticsAsset',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
